import React, { useEffect, useState } from 'react';

const UnsubscribePage = () => {
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Sorry - this page is meant to one-click unsubscribe you from our emails, but no token was detected. Please contact support if you wish to unsubscribe.');
      return;
    }

    fetch(`https://api.thepersonaltrainersclub.com/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(res => {
        if (!res.ok) throw new Error('Unsubscribe failed');
        return res.json();
      })
      .then(data => {
        setStatus('success');
        setMessage(data.message || 'You have been unsubscribed.');
      })
      .catch(err => {
        setStatus('error');
        setMessage('Failed to unsubscribe. Sorry - please contact support if you wish to unsubscribe. ');
      });
  }, []);

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', textAlign: 'center',
            background: 'rgba(0, 0, 0, 0.8)', color: 'white',
            padding: '20px', borderRadius: '8px'
     }}>
      <h2>Unsubscribe</h2>
      {status === 'loading' && <p>Processing your request...</p>}
      {status !== 'loading' && <p>{message}</p>}
    </div>
  );
};

export default UnsubscribePage;
